import { render } from "./BikeRig.vue?vue&type=template&id=ad52e43c"
import script from "./BikeRig.vue?vue&type=script&lang=js"
export * from "./BikeRig.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__